import React from 'react';
import './About.css'
import me from '../../images/me.jpg'
import mail from '../../images/email.png'
import business from '../../images/business.png'
import github from '../../images/github.png'

export const About = () => (
  <div className='aboutWrapper'>
    <div className='aboutFlex'>
      <div className='aboutSidebar'>
        <img src={me} className='me'/>
        <div className="meTags">
          <p>▸ Unreal Engine</p>
          <p>▸ Unity 3D</p>
          <p>▸ C#, JavaScript</p>
          <div className='contactLinksAbout'>
          <a className='aboutLink' target="_blank" rel="noopener noreferrer" href="mailto: alirie.gray@gmail.com"><img src={mail} width='25px'></img></a>
          <a className='aboutLink' target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/alirie-gray/"><img src={business} width='25px'></img></a>
          <a className='aboutLink' target="_blank" rel="noopener noreferrer" href="https://www.github.com/aliriegray/"><img src={github} width='25px'></img></a>
        </div>
        </div>
      </div>
      <div className='aboutContent'>
        <div className="aboutSection">
          I'm a college student and gameplay programmer pursuing a bachelor's degree in computer science at Cal State Northridge and an associate degree in game design at Moorpark College. I worked as a web developer for several years before returning to college recently.
        </div>
        <div className="aboutSection">
          I believe in the storytelling power of video games as a force for good in the world. My goal is to work at a company making games that inspire people and make them think about the world in a new way, as many of my favorite games have done for me.
        </div>
        <div className="aboutSection">
          Currently, I am working on a atmospheric horror game in Unity, <a className='aboutLink' target="_blank" rel="noopener noreferrer" href="https://waxheart.info/">WaxHeart</a>, in my free time and focusing on developing my technical skills.
        </div>
        <div className="aboutSection">
          You can view my coding projects on my <a className='aboutLink' target="_blank" rel="noopener noreferrer" href="https://github.com/AlirieGray/">GitHub</a> and play some of my <a className='aboutLink' target="_blank" rel="noopener noreferrer" href='https://alirie.itch.io/'>games on itch.io</a>.
        </div>
      </div>
    </div>
  </div>  
);